module.exports = __webpack_public_path__ + "img/withdrawal.15cb6e23.png";